import './project-header.scss';

import { ThunkDispatch } from 'redux-thunk';

import * as Model from '../../../models';
import * as I18n from '../../../models/i18n';
import * as ProjectActions from '../../../actions/project-actions';

import { OligoModalSupport, OligoModalSupportStatus, OligoModalSupportStatuses, OligoModalTypes } from '../../oligo-modal-support/oligo-modal-support';
import { PROJECT_PREFERENCE_SHOW } from '../project-preference/project-preference';

export const PROJECT_HEADER_NAME: string = 'projectHeader';

export interface ProjectHeaderOptions {
  project: Model.ProjectItemOrNull;
}

type I18nAware = {
  HEADER_TITLE_TPL: string;
  HEADER_TITLE: string;
  PROJECT_PREFERENCE_LABEL: string;
  DELETE_POPOVER_TITLE_PROJECT: string;
  DELETE_POPOVER_DESC_PROJECT: string;
  POPOVER_LABEL_DELETE_CONFIRM: string;
  POPOVER_CANCEL_LABEL: string;
};

export class ProjectHeaderController implements ng.IComponentController, I18nAware, ProjectHeaderOptions, ProjectActions.ProjectDeleteSupport {

  public project: Model.ProjectItemOrNull = null;
  public deleteProject: ProjectActions.ProjectDelete | null = null;
  public loading: boolean = false;

  public PROJECT_PREFERENCE_LABEL: string = 'Set project preferences';
  public DELETE_POPOVER_TITLE_PROJECT: string = 'Delete Project(s)?';
  public DELETE_POPOVER_DESC_PROJECT: string = 'Are you sure you want to delete the project(s)? This action cannot be undone.';
  public POPOVER_LABEL_DELETE_CONFIRM: string = 'Yes';
  public POPOVER_CANCEL_LABEL: string = 'Cancel';
  public HEADER_TITLE_TPL: string = 'Project {{PROJECT_NUMBER}}';
  public HEADER_TITLE: string = '';
  public showProjectPreference: boolean = false;

  constructor(private $scope: ng.IScope,
              $ngRedux: Model.INgRedux,
              projectActions: ProjectActions.ProjectActions,
              private oligoModalSupport: OligoModalSupport | null) {
    const bindDispatchers = (dispatch: ThunkDispatch<Model.RootState, object, Model.ReduxAction<object>>) => {
      this.deleteProject = (request: ProjectActions.ProjectDeleteFnRequest) => {
        return dispatch(projectActions.deleteProject(request));
      };
    };
    const unsubscribe = $ngRedux.connect(this.mapStateToThis.bind(this), bindDispatchers)(this);
    const unwatch = $scope.$watch(() => this.project, (project: Model.ProjectItemOrNull) => {
      if (!project) {
        return;
      }
      this.HEADER_TITLE = I18n.replacePlaceHolders(this.HEADER_TITLE_TPL, { [I18n.PlaceHolderKeys.PROJECT_NUMBER]: `${project.index + 1}` });
    });
    $scope.$on('$destroy', () => {
      unwatch();
      unsubscribe();
    });
  }

  public showPreference(): void {
    this.showProjectPreference = !this.showProjectPreference;
    if (this.showProjectPreference) {
      this.$scope.$broadcast(PROJECT_PREFERENCE_SHOW, this.project);
    }
  }

  public publishProjectDelete(): void {
    const { deleteProject, project, oligoModalSupport } = this;
    if (!deleteProject || !project || !oligoModalSupport) {
      return;
    }
    const { id, index } = project;
    oligoModalSupport.show({
      title: this.DELETE_POPOVER_TITLE_PROJECT,
      content: this.DELETE_POPOVER_DESC_PROJECT,
      okLabel: this.POPOVER_LABEL_DELETE_CONFIRM,
      cancelLabel: this.POPOVER_CANCEL_LABEL,
      type: OligoModalTypes.CONFIRM,
    }).then((status: OligoModalSupportStatus) => {
      switch (status) {
        case OligoModalSupportStatuses.OK:
          this.loading = true;
          deleteProject({ id, index })
            .finally(() => this.loading = false);
          break;
        case OligoModalSupportStatuses.CANCEL:
        case OligoModalSupportStatuses.CLOSE:
        default:
          break;
      }
    });
  }

  public $onDestroy(): void {
    this.project = null;
    this.deleteProject = null;
    this.oligoModalSupport = null;
  }

  private mapStateToThis(state: Model.RootState): I18nAware {
    const { world } = state;
    const { vocabulary } = world;
    const HEADER_TITLE_TPL: string = vocabulary[I18n.DictionaryKeys.PROJECT_HEADER_TITLE] || this.HEADER_TITLE_TPL;
    return {
      HEADER_TITLE_TPL,
      HEADER_TITLE: I18n.replacePlaceHolders(HEADER_TITLE_TPL, { [I18n.PlaceHolderKeys.PROJECT_NUMBER]: this.project ? `${this.project.index + 1}` : '' }),
      PROJECT_PREFERENCE_LABEL: vocabulary[I18n.DictionaryKeys.PROJECT_HEADER_PREFERENCE_BUTTON] || this.PROJECT_PREFERENCE_LABEL,
      DELETE_POPOVER_TITLE_PROJECT: vocabulary[I18n.DictionaryKeys.PROJECT_DELETE_POPOVER_TITLE] || this.DELETE_POPOVER_TITLE_PROJECT,
      DELETE_POPOVER_DESC_PROJECT: vocabulary[I18n.DictionaryKeys.PROJECT_DELETE_POPOVER_DESC] || this.DELETE_POPOVER_DESC_PROJECT,
      POPOVER_LABEL_DELETE_CONFIRM: vocabulary[I18n.DictionaryKeys.PROJECT_DELETE_POPOVER_OK_BUTTON] || this.POPOVER_LABEL_DELETE_CONFIRM,
      POPOVER_CANCEL_LABEL: vocabulary[I18n.DictionaryKeys.PROJECT_DELETE_POPOVER_CANCEL_BUTTON] || this.POPOVER_CANCEL_LABEL,
    };
  }
}

export const ProjectHeader: ng.IComponentOptions = {
  template: require('./project-header.tpl.html'),
  controller: ProjectHeaderController,
  controllerAs: 'projectHeader',
  bindings: {
    project: '<',
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/project-detail/project-header/project-header.ts